import { getLanguageCode, setLanguageCode } from "../storage";

export const DEFAULT_LANGUAGE = "en";

const NAMESPACES = ["applicaster.v2", "quick-brick-login-flow"];

export function normalizeLanguageCode(value: string | null | undefined): string | null {
  if (!value) return null;
  const code = value.trim().toLowerCase().split(/[-_]/)[0];
  return code || null;
}

async function readBridgeItem(
  storage: "sessionStorage" | "localStorage",
  key: string,
  namespace: string,
): Promise<string | null> {
  console.log(`[language.service] reading ${storage}.getItem(${JSON.stringify(key)}, "${namespace}")...`);
  try {
    const bridge = window.Applicaster?.JS2Native;
    const value = await bridge?.[storage]?.getItem(key, namespace);
    console.log(`[language.service] ${storage}.getItem(${JSON.stringify(key)}, "${namespace}") =>`, value);
    return typeof value === "string" ? value : null;
  } catch (error) {
    console.log(`[language.service] ${storage}.getItem(${JSON.stringify(key)}, "${namespace}") threw:`, error);
    return null;
  }
}

async function readBridgeItemAcrossNamespaces(
  storage: "sessionStorage" | "localStorage",
  key: string,
): Promise<string | null> {
  for (const namespace of NAMESPACES) {
    const value = await readBridgeItem(storage, key, namespace);
    if (value) return value;
  }
  return null;
}

async function readApplicasterLanguageCode(): Promise<string | null> {
  const fromSession = await readBridgeItemAcrossNamespaces("sessionStorage", "languageCode");
  if (fromSession) return fromSession;
  return readBridgeItemAcrossNamespaces("localStorage", "languageLocale");
}

let cachedLanguageCode: Promise<string | null> | null = null;

export function getApplicasterSessionInfo(): Promise<{ languageCode: string | null }> {
  cachedLanguageCode ??= readApplicasterLanguageCode();

  return cachedLanguageCode.then((languageCode) => ({ languageCode }));
}

function getBrowserLanguageCode(): string | null {
  if (typeof navigator === "undefined") return null;
  return normalizeLanguageCode(navigator.language ?? navigator.languages?.[0]);
}

export async function resolveLanguage(): Promise<string> {
  console.log("[language.service] resolveLanguage() starting — before any Strapi call");
  const { languageCode } = await getApplicasterSessionInfo();
  const normalized = normalizeLanguageCode(languageCode);
  if (normalized) {
    setLanguageCode(normalized);
    console.log(
      `[language.service] resolveLanguage() resolved "${normalized}" from Applicaster — calling Strapi with this now`,
    );
    return normalized;
  }
  const stored = normalizeLanguageCode(getLanguageCode()) ?? getBrowserLanguageCode() ?? DEFAULT_LANGUAGE;
  console.log(
    `[language.service] resolveLanguage() found nothing from Applicaster, falling back to "${stored}" — calling Strapi with this now`,
  );
  return stored;
}
